import './index.css';

const rootElement = document.getElementById('root')!;

void import('./hydrate').then((mod) => {
  const run = () => {
    void mod.hydrateApp(rootElement);
  };
  if (rootElement.hasChildNodes() && typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(run);
  } else {
    run();
  }
});
